import { Observable } from 'rxjs';
import { SummaryResponse } from '../models/summary-response.model';

export abstract class SummaryRepository {
    abstract getSummary(): Observable<SummaryResponse>;
}
